module.exports = __webpack_public_path__ + "static/media/orangeArrow.68d873f1.svg";